export var DATA_ACCORDION_ITEM = 'data-accordion-item';
export var ARIA_CONTROLS = '[data-control]';
export var getAccordionLevel = element => {
  var levelIndex = 1;

  while (element.parentNode) {
    element = element.parentNode;
    /* istanbul ignore else */

    if (element && element.getAttribute && element.getAttribute(DATA_ACCORDION_ITEM)) {
      levelIndex++;
    }
  }

  return levelIndex;
};
export var getParentByAttribute = (element, attribute) => {
  while (element.parentNode) {
    element = element.parentNode;
    /* istanbul ignore else */

    if (element && element.getAttribute && element.getAttribute(attribute)) {
      return element;
    }
  }

  return null;
};
export var getParentHasNextSiblings = function getParentHasNextSiblings(element, attribute) {
  if (attribute === void 0) {
    attribute = '';
  }

  while (element.parentNode) {
    var _element;

    element = element.parentNode;
    /* istanbul ignore else */

    if (element && element.getAttribute && element.getAttribute(attribute) && (_element = element) != null && _element.nextElementSibling) {
      return element;
    }
  }

  return null;
};
export var getAllSiblings = (elem, filter) => {
  var _elem, _elem$parentNode;

  var sibs = [];
  elem = ((_elem = elem) == null ? void 0 : (_elem$parentNode = _elem.parentNode) == null ? void 0 : _elem$parentNode.firstChild) || null;

  do {
    var _elem2, _elem3;

    /* istanbul ignore else */
    if (((_elem3 = elem) == null ? void 0 : _elem3.nodeType) === 3) {
      continue; // text node
    }
    /* istanbul ignore else */


    if (!filter || filter(elem)) {
      sibs.push(elem);
    }
  } while (elem = ((_elem2 = elem) == null ? void 0 : _elem2.nextSibling) || null);

  return sibs;
};
export var isValidTrigger = item => {
  var parent = getParentByAttribute(item, DATA_ACCORDION_ITEM);
  /* istanbul ignore else */

  if (parent) {
    var panel = parent.querySelector('[data-accordion-panel]');
    /* istanbul ignore else */

    if (panel && panel.getAttribute('data-state') === 'open') {
      return true;
    }
  }

  return false;
};
export var goToHome = element => {
  /* istanbul ignore else */
  if (!element) {
    return;
  }

  var siblingsHome = getAllSiblings(element);
  /* istanbul ignore else */

  if ((siblingsHome == null ? void 0 : siblingsHome.length) > 0) {
    var firstButton = siblingsHome[0].querySelector(ARIA_CONTROLS);
    firstButton == null ? void 0 : firstButton.focus();
  }
};
export var goToEnd = element => {
  /* istanbul ignore else */
  if (!element) {
    return;
  }

  var siblingsEnd = getAllSiblings(element);
  /* istanbul ignore else */

  if (siblingsEnd.length > 0) {
    var lastButton = siblingsEnd[siblingsEnd.length - 1].querySelector(ARIA_CONTROLS);
    lastButton == null ? void 0 : lastButton.focus();
  }
};
export var goToPreviousItem = (target, currentTarget) => {
  var _getParentByAttribute;

  var prev = (_getParentByAttribute = getParentByAttribute(target, DATA_ACCORDION_ITEM)) == null ? void 0 : _getParentByAttribute.previousElementSibling;

  if (prev) {
    var _prev$querySelector;

    var [lastItem] = [...prev.querySelectorAll('[data-accordion-item]')].slice().reverse().filter(item => isValidTrigger(item));

    if (lastItem) {
      var _lastItem$querySelect;

      (_lastItem$querySelect = lastItem.querySelector(ARIA_CONTROLS)) == null ? void 0 : _lastItem$querySelect.focus();
      return;
    }

    (_prev$querySelector = prev.querySelector(ARIA_CONTROLS)) == null ? void 0 : _prev$querySelector.focus();
    return;
  }

  var lastTarget = getParentByAttribute(currentTarget, DATA_ACCORDION_ITEM);

  if (lastTarget) {
    var _lastTarget$querySele;

    lastTarget == null ? void 0 : (_lastTarget$querySele = lastTarget.querySelector(ARIA_CONTROLS)) == null ? void 0 : _lastTarget$querySele.focus();
    return;
  }

  if (!lastTarget) {
    var accordion = getParentByAttribute(currentTarget, 'data-accordion');
    var [_lastItem] = [...accordion.querySelectorAll('[data-accordion-item]')].slice().reverse();
    var lastItemParent = getParentByAttribute(_lastItem, DATA_ACCORDION_ITEM);

    if (lastItemParent && lastItemParent.getAttribute('data-state') === 'open' || !lastItemParent) {
      _lastItem == null ? void 0 : _lastItem.querySelector(ARIA_CONTROLS).focus();
    } else {
      if (lastItemParent) {
        lastItemParent == null ? void 0 : lastItemParent.querySelector(ARIA_CONTROLS).focus();
      }
    }
  }
};
export var goToNextItem = (target, currentTarget) => {
  var _getParentByAttribute2, _getParentByAttribute3;

  var child = (_getParentByAttribute2 = getParentByAttribute(target, DATA_ACCORDION_ITEM)) == null ? void 0 : _getParentByAttribute2.querySelector('[data-accordion-item]');

  if (child && isValidTrigger(child)) {
    var _child$querySelector;

    (_child$querySelector = child.querySelector(ARIA_CONTROLS)) == null ? void 0 : _child$querySelector.focus();
    return;
  }

  var next = (_getParentByAttribute3 = getParentByAttribute(target, DATA_ACCORDION_ITEM)) == null ? void 0 : _getParentByAttribute3.nextElementSibling;
  /* istanbul ignore else */

  if (next) {
    var _next$querySelector;

    (_next$querySelector = next.querySelector(ARIA_CONTROLS)) == null ? void 0 : _next$querySelector.focus();
    return;
  }
  /* istanbul ignore else */


  if (!next) {
    var current = getParentByAttribute(target, DATA_ACCORDION_ITEM);
    var parent = current && getParentHasNextSiblings(current, DATA_ACCORDION_ITEM);
    /* istanbul ignore else */

    if (parent) {
      var _parent$nextElementSi;

      parent == null ? void 0 : (_parent$nextElementSi = parent.nextElementSibling.querySelector(ARIA_CONTROLS)) == null ? void 0 : _parent$nextElementSi.focus();
      return;
    } else {
      var _accordion$querySelec;

      var accordion = getParentByAttribute(current, 'data-accordion');
      accordion == null ? void 0 : (_accordion$querySelec = accordion.querySelector(ARIA_CONTROLS)) == null ? void 0 : _accordion$querySelec.focus();
    }
  }
};
//# sourceMappingURL=dom.js.map